// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TSendFormAnalyticsRequest, TSendFormAnalyticsModel, IMappers, TSendFormAnalyticsResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ISendFormAnalyticsResponse } from '../../entities/send_form_analytics/SendFormAnalyticsResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createSendFormAnalyticsModel(parameters: TSendFormAnalyticsRequest): TSendFormAnalyticsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'lead-realtor-form',
    pathApi: '/v1/send-form-analytics/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ISendFormAnalyticsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TSendFormAnalyticsRequest;
}

export async function fetchSendFormAnalytics<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISendFormAnalyticsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TSendFormAnalyticsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSendFormAnalyticsModel(parameters),
    config,
  )) as FetchResponse<TSendFormAnalyticsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISendFormAnalyticsResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TSendFormAnalyticsResponse>;
}
